import LoadMoreDataZone, { LoadMoreDataComponentProps } from './LoadMoreDataZone';
import { observer } from 'mobx-react';
import { logMountingPerformance } from 'owa-analytics';
import * as React from 'react';

export interface LoadMoreListViewProps extends LoadMoreDataComponentProps {
    itemIds: string[];
    onRenderRow: (itemId: string, itemIndex: number, listProps: any) => JSX.Element;

    // Gets a header element if needed to be rendered
    onRenderHeader?: (previousItemId: string, currentItemId: string) => JSX.Element;

    // Draws the loading component at the bottom while fetching more data
    loadingComponent?: JSX.Element;

    // Row wrapper div class
    rowWrapperClass?: string;

    // Draws a custom component before the rows of the list
    preRowsComponent?: JSX.Element;

    // Draws a custom component after the rows of the list
    postRowsComponent?: JSX.Element;

    // Props related to the list container, to be passed to each item on render
    listProps?: any;
}

@observer
@logMountingPerformance('VLVLoadMoreRender')
export default class LoadMoreListView extends React.Component<LoadMoreListViewProps, any> {
    private dataZone: LoadMoreDataZone;

    render() {
        return (
            <LoadMoreDataZone
                ref={ref => (this.dataZone = ref)}
                className={this.props.className}
                dataSourceId={this.props.dataSourceId}
                totalRows={this.props.itemIds.length}
                onScroll={this.props.onScroll}
                onRenderRows={this.renderRows}
                onLoadMoreRows={this.props.onLoadMoreRows}
                isLoadRowsInProgress={this.props.isLoadRowsInProgress}
                getCanLoadMore={this.props.getCanLoadMore}
                onWillUpdate={this.props.onWillUpdate}
                onDidUpdate={this.props.onDidUpdate}
                currentLoadedIndex={this.props.currentLoadedIndex}
                guardPageCount={this.props.guardPageCount}
            />
        );
    }

    public setFocus() {
        this.dataZone.setFocus();
    }

    public restoreSavedScrollPosition() {
        this.dataZone.restoreSavedScrollPosition();
    }

    public storeScrollPosition() {
        this.dataZone.storeScrollPosition();
    }

    public scrollToBottom() {
        this.dataZone.scrollToBottom();
    }

    private renderRows = (rowsToRender: number): JSX.Element => {
        let rows: JSX.Element[] = [];
        for (let i = 0; i < rowsToRender; i++) {
            if (this.props.onRenderHeader) {
                const previousElementId = i > 0 ? this.props.itemIds[i - 1] : null;
                const header = this.props.onRenderHeader(previousElementId, this.props.itemIds[i]);
                if (header) {
                    rows.push(header);
                }
            }

            rows.push(this.props.onRenderRow(this.props.itemIds[i], i, this.props.listProps));
        }

        let isLoadInProgress = this.props.isLoadRowsInProgress;

        return (
            <div className={this.props.rowWrapperClass}>
                {this.props.preRowsComponent}
                {rows}
                {this.props.postRowsComponent}
                {isLoadInProgress && this.props.loadingComponent}
            </div>
        );
    };
}
